/**
 * @desc 删除分区
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.zoneTemplate.remove.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/zoneTemplate/delete`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
